msgid ""
msgstr ""
"POT-Creation-Date: 2026-07-09 18:50+0200\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: nplurals=2; plural=(n != 1);\n"

#. js-lingui-explicit-id
#: src/pages/Mementos/tabs/Mementos/partials/MementoItem/MementoItem.jsx
msgid "Completar tarea como:"
msgstr "Complete task as:"

#. js-lingui-explicit-id
#: src/pages/Mementos/hooks/useMementoActions.js
msgid "Memento guardado"
msgstr "Task saved"

#. js-lingui-explicit-id
#: src/pages/Mementos/hooks/useMementoActions.js
msgid "Memento creado"
msgstr "Task created"

#. js-lingui-explicit-id
#: src/pages/Mementos/hooks/useMementoActions.js
msgid "Memento marcado como completado"
msgstr "Task marked as completed"

#. js-lingui-explicit-id
#: src/pages/Mementos/hooks/useMementoActions.js
msgid "Memento eliminado"
msgstr "Task deleted"

#: src/pages/Settings/partials/OptionItem/OptionItem.jsx
msgid "- Menos información"
msgstr "- Less information"

#: src/pages/Onboarding/GroupView.jsx
msgid "¡Bien hecho!"
msgstr "Well done!"

#: src/components/Crew/CrewMembers/CrewMembers.jsx
msgid "¡Copiado!"
msgstr "Copied!"

#: src/pages/Mementos/tabs/Mementos/Mementos.jsx
msgid "¡Nada pendiente para esta semana!"
msgstr "Nothing pending for this week!"

#: src/pages/Mementos/TasksDashboard/TasksDashboard.jsx
msgid "¡No tienes tareas pendientes!"
msgstr "You have no pending tasks!"

#: src/pages/Mementos/tabs/MementosContributions/MementosContributions.jsx
msgid "¡Todavía no hay contribuciones!"
msgstr "There are no contributions yet!"

#: src/pages/Mementos/TasksDashboard/partials/StatCard/StatCard.jsx
msgid "¡Todo bien!"
msgstr "All good!"

#: src/pages/Login/partials/MagicLinkStep.jsx
msgid "¿No llega el email? Revisa la carpeta de spam."
msgstr "Email not arriving? Check your spam folder."

#: src/pages/Login/partials/EmailStep.jsx
msgid "¿No tienes cuenta? Regístrate"
msgstr "Don't have an account? Sign up"

#: src/pages/Items/tabs/Predictions/Predictions.jsx
msgid "¿Qué es esto?"
msgstr "What is this?"

#: src/pages/Onboarding/GroupView.jsx
msgid "¿Qué es un espacio?"
msgstr "What is a workspace?"

#: src/pages/Dashboard/DashboardView.jsx
msgid "¿Qué quieres hacer hoy?"
msgstr "What do you want to do today?"

#: src/pages/SplitExpenses/partials/SplitExpenseFields.jsx
msgid "¿Seguro que quieres eliminar este gasto? Esta acción no se puede deshacer."
msgstr "Are you sure you want to delete this expense? This action cannot be undone."

#: src/pages/SplitExpenses/partials/SplitExpenseGroupFields.jsx
msgid "¿Seguro que quieres eliminar este grupo? Se borrarán todos los gastos asociados."
msgstr "Are you sure you want to delete this group? All associated expenses will be deleted."

#: src/pages/Recipes/RecipeShareView.jsx
msgid "¿Te gusta esta receta? Crea las tuyas gratis en Economos."
msgstr "Like this recipe? Create your own for free on Economos."

#: src/components/Crew/CrewMembers/partials/CrewMember/CrewMember.jsx
msgid "(tú)"
msgstr "(you)"

#: src/pages/Legal/PrivacyView.jsx
msgid "[PENDIENTE: razón social, NIF y domicilio social del titular] (en adelante, \"el responsable\"), correo de contacto: [PENDIENTE: privacy@…]."
msgstr "[PENDING: company name, tax ID and registered address of the owner] (hereinafter, \"the controller\"), contact email: [PENDING: privacy@…]."

#. placeholder {0}: filteredHouseItems.length
#. js-lingui:icu=%7B0%2C+plural%2C+one+%7B%23+%C3%ADtem+restante%7D+other+%7B%23+%C3%ADtems+restantes%7D%7D&pluralize_on=0
#: src/pages/Items/tabs/Items/Items.jsx
msgid "# ítem restante"
msgid_plural "# ítems restantes"
msgstr[0] "# item remaining"
msgstr[1] "# items remaining"

#. placeholder {0}: items.length
#. js-lingui:icu=%7B0%2C+plural%2C+one+%7B%23+%C3%ADtem%7D+other+%7B%23+%C3%ADtems%7D%7D&pluralize_on=0
#: src/pages/Economos/Search/EconomosSearchView.jsx
msgid "# ítem"
msgid_plural "# ítems"
msgstr[0] "# item"
msgstr[1] "# items"

#. placeholder {0}: (recipe.servings ?? 0) * numericMultiplier
#. placeholder {0}: recipe.servings
#. placeholder {0}: recipe.servings * numericMultiplier
#. js-lingui:icu=%7B0%2C+plural%2C+one+%7B%23+raci%C3%B3n%7D+other+%7B%23+raciones%7D%7D&pluralize_on=0
#: src/pages/Recipes/RecipeDetail.jsx
#: src/pages/Recipes/RecipeShareView.jsx
#: src/pages/Recipes/RecipesView.jsx
msgid "# ración"
msgid_plural "# raciones"
msgstr[0] "# serving"
msgstr[1] "# servings"

#. placeholder {0}: group.users?.length ?? 0
#. js-lingui:icu=%7B0%2C+plural%2C+one+%7B%23+usuario%7D+other+%7B%23+usuarios%7D%7D&pluralize_on=0
#: src/pages/SplitExpenses/SplitExpensesGroupView.jsx
msgid "# usuario"
msgid_plural "# usuarios"
msgstr[0] "# user"
msgstr[1] "# users"

#. placeholder {0}: expensesPerUser.toFixed(2)
#: src/pages/SplitExpenses/SplitExpensesView.jsx
msgid "{0} € por persona"
msgstr "{0} € per person"

#. placeholder {0}: list.length
#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/Recommendations.jsx
msgid "{0} recomendaciones"
msgstr "{0} recommendations"

#. js-lingui:icu=%7Bcount%2C+plural%2C+one+%7Btarea%7D+other+%7Btareas%7D%7D&pluralize_on=count
#: src/pages/Mementos/TasksDashboard/partials/CompletedStatCard/CompletedStatCard.jsx
#: src/pages/Mementos/TasksDashboard/partials/StatCard/StatCard.jsx
msgid "tarea"
msgid_plural "tareas"
msgstr[0] "task"
msgstr[1] "tasks"

#. js-lingui:icu=%7BdaysUntilEndOfMonth%2C+plural%2C+one+%7B%23+d%C3%ADa+restante%7D+other+%7B%23+d%C3%ADas+restantes%7D%7D&pluralize_on=daysUntilEndOfMonth
#: src/pages/Economos/Movements/partials/EconomosMonthBalance/EconomosMonthBalance.jsx
msgid "# día restante"
msgid_plural "# días restantes"
msgstr[0] "# day remaining"
msgstr[1] "# days remaining"

#. js-lingui:icu=%7BmovementsToCreateCount%2C+plural%2C+one+%7BSe+crear%C3%A1+%23+movimiento%7D+other+%7BSe+crear%C3%A1n+%23+movimientos%7D%7D&pluralize_on=movementsToCreateCount
#: src/pages/Economos/Movements/partials/EconomosRecurrenceSelector/EconomosRecurrenceSelector.jsx
msgid "Se creará # movimiento"
msgid_plural "Se crearán # movimientos"
msgstr[0] "# movement will be created"
msgstr[1] "# movements will be created"

#. js-lingui:icu=%7BnewCount%2C+plural%2C+one+%7BCrear+%23+%C3%ADtem%7D+other+%7BCrear+%23+%C3%ADtems%7D%7D&pluralize_on=newCount
#: src/pages/Items/tabs/Items/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Crear # ítem"
msgid_plural "Crear # ítems"
msgstr[0] "Create # item"
msgstr[1] "Create # items"

#. js-lingui:icu=%7BnewCount%2C+plural%2C+one+%7BCrear+%23+tarea%7D+other+%7BCrear+%23+tareas%7D%7D&pluralize_on=newCount
#: src/pages/Mementos/tabs/Mementos/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Crear # tarea"
msgid_plural "Crear # tareas"
msgstr[0] "Create # task"
msgstr[1] "Create # tasks"

#: src/pages/Settings/partials/OptionItem/OptionItem.jsx
msgid "+ Más información"
msgstr "+ More information"

#: src/pages/Items/ItemsView.jsx
msgid "📚 Categorías"
msgstr "📚 Categories"

#: src/pages/Mementos/MementosView.jsx
msgid "📚 Tareas"
msgstr "📚 Tasks"

#: src/pages/Items/ItemsView.jsx
msgid "📦 Ítems"
msgstr "📦 Items"

#: src/pages/Items/ItemsView.jsx
msgid "🔮 Predicciones"
msgstr "🔮 Predictions"

#: src/pages/Mementos/MementosView.jsx
msgid "🤝 Contribuciones"
msgstr "🤝 Contributions"

#: src/pages/Legal/TermsView.jsx
msgid "1. Objeto"
msgstr "1. Purpose"

#: src/pages/Legal/CookiesView.jsx
msgid "1. Qué son las cookies"
msgstr "1. What are cookies"

#: src/pages/Legal/PrivacyView.jsx
msgid "1. Responsable del tratamiento"
msgstr "1. Data controller"

#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "10 años"
msgstr "10 years"

#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "12 meses"
msgstr "12 months"

#: src/pages/Legal/CookiesView.jsx
msgid "2. Cookies que utilizamos"
msgstr "2. Cookies we use"

#: src/pages/Legal/TermsView.jsx
msgid "2. Cuenta de usuario"
msgstr "2. User account"

#: src/pages/Legal/PrivacyView.jsx
msgid "2. Datos que tratamos"
msgstr "2. Data we process"

#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "3 años"
msgstr "3 years"

#: src/pages/Legal/CookiesView.jsx
msgid "3. Almacenamiento local (localStorage)"
msgstr "3. Local storage (localStorage)"

#: src/pages/Legal/TermsView.jsx
msgid "3. Espacios colaborativos"
msgstr "3. Collaborative workspaces"

#: src/pages/Legal/PrivacyView.jsx
msgid "3. Finalidad y base jurídica"
msgstr "3. Purpose and legal basis"

#: src/pages/Legal/CookiesView.jsx
msgid "4. Cookies no exentas (con tu consentimiento)"
msgstr "4. Non-exempt cookies (with your consent)"

#: src/pages/Legal/PrivacyView.jsx
msgid "4. Destinatarios y transferencias internacionales"
msgstr "4. Recipients and international transfers"

#: src/pages/Legal/TermsView.jsx
msgid "4. Propiedad intelectual"
msgstr "4. Intellectual property"

#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "5 años"
msgstr "5 years"

#: src/pages/Legal/CookiesView.jsx
msgid "5. Cómo gestionar tu consentimiento"
msgstr "5. How to manage your consent"

#: src/pages/Legal/PrivacyView.jsx
msgid "5. Conservación"
msgstr "5. Retention"

#: src/pages/Legal/TermsView.jsx
msgid "5. Disponibilidad y limitación de responsabilidad"
msgstr "5. Availability and limitation of liability"

#: src/pages/Legal/TermsView.jsx
msgid "6. Condiciones de contratación (pagos)"
msgstr "6. Contract terms (payments)"

#: src/pages/Legal/PrivacyView.jsx
msgid "6. Tus derechos"
msgstr "6. Your rights"

#: src/pages/Legal/PrivacyView.jsx
msgid "7. Cookies"
msgstr "7. Cookies"

#: src/pages/Legal/TermsView.jsx
msgid "7. Modificaciones y extinción"
msgstr "7. Changes and termination"

#: src/pages/Legal/TermsView.jsx
msgid "8. Ley aplicable"
msgstr "8. Applicable law"

#: src/pages/SplitExpenses/SplitExpensesView.jsx
msgid "a"
msgstr "to"

#: src/pages/Items/tabs/Items/partials/HouseItem/partials/Stock.jsx
#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
msgid "Abundante"
msgstr "Abundant"

#: src/pages/Login/LoginView.jsx
msgid "Accede a Economos"
msgstr "Sign in to Economos"

#: src/pages/Settings/Settings.jsx
msgid "Aceptadas"
msgstr "Accepted"

#: src/components/common/CookieConsentBanner/CookieConsentBanner.jsx
msgid "Aceptar"
msgstr "Accept"

#: src/components/common/CookieConsentBanner/CookieConsentBanner.jsx
msgid "Aceptar cookies"
msgstr "Accept cookies"

#: src/pages/CrewInvitation/CrewInvitationView.jsx
msgid "Aceptar invitación"
msgstr "Accept invitation"

#: src/pages/Register/RegisterView.jsx
msgid "Acepto los <0>términos y condiciones</0> y la <1>política de privacidad</1>."
msgstr "I accept the <0>terms and conditions</0> and the <1>privacy policy</1>."

#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
msgid "Activar después de"
msgstr "Activate after"

#. placeholder {0}: dayjs(group.lastActivity).fromNow()
#: src/pages/SplitExpenses/SplitExpensesGroupView.jsx
msgid "Activo {0}"
msgstr "Active {0}"

#. placeholder {0}: dayjs(usageOverview.currentPeriodEnd).format("DD/MM/YYYY")
#: src/pages/Usage/UsageView.jsx
msgid "Activo hasta el {0}"
msgstr "Active until {0}"

#: src/pages/Items/tabs/Items/partials/HouseItem/partials/StockPopover/StockPopover.jsx
msgid "Actualiza el stock en tu despensa y se contará como una compra."
msgstr "Update the stock in your pantry and it will count as a purchase."

#: src/components/Crew/CrewMembers/partials/CrewMember/CrewMember.jsx
msgid "Administrador"
msgstr "Administrator"

#: src/pages/Items/tabs/Items/partials/HouseItem/partials/Stock.jsx
#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
msgid "Agotado"
msgstr "Out of stock"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Ahora podrás crear uno nuevo a partir del duplicado"
msgstr "You can now create a new one from the duplicate"

#: src/Layouts/private/partials/UserInfo.jsx
msgid "Ajustes"
msgstr "Settings"

#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
msgid "Alguien ha editado esta tarea"
msgstr "Someone has edited this task"

#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
msgid "Alguien ha editado este ítem"
msgstr "Someone has edited this item"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Alguien ha editado este movimiento"
msgstr "Someone has edited this movement"

#: src/pages/Items/tabs/Items/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Alimentos básicos"
msgstr "Basic foods"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Añade al menos un ingrediente"
msgstr "Add at least one ingredient"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Añade al menos un paso"
msgstr "Add at least one step"

#: src/pages/SplitExpenses/partials/SplitExpenseGroupFields.jsx
msgid "Añade al menos un usuario"
msgstr "Add at least one user"

#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
msgid "Añade una descripción (opcional)"
msgstr "Add a description (optional)"

#: src/pages/SplitExpenses/SplitExpensesView.jsx
msgid "Añade usuarios al grupo para crear gastos"
msgstr "Add users to the group to create expenses"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Añadir ingrediente"
msgstr "Add ingredient"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Añadir paso"
msgstr "Add step"

#: src/pages/Economos/Movements/partials/EconomosApps/EconomosApps.jsx
#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "Análisis"
msgstr "Analysis"

#: src/pages/Economos/Movements/partials/SwipeableEconomosItem/SwipeableEconomosItem.jsx
msgid "Analizar"
msgstr "Analyze"

#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
msgid "Anclado"
msgstr "Pinned"

#: src/pages/Items/tabs/Items/Items.jsx
msgid "Anclar ítems"
msgstr "Pin items"

#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "Anual"
msgstr "Yearly"

#: src/pages/Economos/Movements/partials/EconomosApps/EconomosApps.jsx
msgid "Aplicaciones"
msgstr "Apps"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/Calculator.jsx
msgid "Aplicar"
msgstr "Apply"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/Recommendations.jsx
msgid "Aplicar todo"
msgstr "Apply all"

#: src/Layouts/private/partials/AppSelector.jsx
msgid "Apunta quién paga qué entre varias personas y salda las deudas de una sola vez."
msgstr "Track who pays what among multiple people and settle debts in one go."

#: src/components/common/ui/button/BackButton/BackButton.jsx
msgid "Atrás"
msgstr "Back"

#: src/pages/Mementos/TasksDashboard/TasksDashboard.jsx
msgid "Atrasadas"
msgstr "Overdue"

#: src/components/common/UsageLimit/UsageLimit.jsx
msgid "Aumenta tu límite actualizando al plan"
msgstr "Increase your limit by upgrading your plan"

#: src/components/common/ui/dates/Datepicker.jsx
msgid "Ayer"
msgstr "Yesterday"

#: src/components/common/ui/feedback/HelpIcon/HelpIcon.jsx
msgid "Ayuda"
msgstr "Help"

#: src/pages/Settings/Settings.jsx
msgid "Botón hamburguesa para el pulgar en versión móvil."
msgstr "Thumb-friendly hamburger button on mobile."

#: src/components/common/ui/combobox/CategoryCombobox.jsx
msgid "Busca categoría"
msgstr "Search category"

#: src/pages/Economos/Movements/partials/EconomosApps/EconomosApps.jsx
#: src/pages/Economos/Search/EconomosSearchView.jsx
msgid "Buscar"
msgstr "Search"

#: src/pages/Items/tabs/Categories/Categories.jsx
#: src/pages/Items/tabs/Items/Items.jsx
#: src/pages/Recipes/RecipesView.jsx
msgid "Búsqueda"
msgstr "Search"

#: src/pages/Mementos/tabs/Mementos/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "cada {frequencyDays} días"
msgstr "every {frequencyDays} days"

#: src/pages/Economos/Movements/partials/EconomosRecurrenceSelector/EconomosRecurrenceSelector.jsx
msgid "Cada 2 meses"
msgstr "Every 2 months"

#: src/pages/Economos/Movements/partials/EconomosRecurrenceSelector/EconomosRecurrenceSelector.jsx
msgid "Cada 2 semanas"
msgstr "Every 2 weeks"

#: src/pages/Economos/Movements/partials/EconomosRecurrenceSelector/EconomosRecurrenceSelector.jsx
msgid "Cada 6 meses"
msgstr "Every 6 months"

#: src/pages/Economos/Movements/partials/EconomosRecurrenceSelector/EconomosRecurrenceSelector.jsx
msgid "Cada año"
msgstr "Every year"

#: src/pages/Mementos/tabs/Mementos/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "cada día"
msgstr "every day"

#: src/pages/Economos/Movements/partials/EconomosRecurrenceSelector/EconomosRecurrenceSelector.jsx
msgid "Cada mes"
msgstr "Every month"

#: src/pages/Economos/Movements/partials/EconomosRecurrenceSelector/EconomosRecurrenceSelector.jsx
msgid "Cada semana"
msgstr "Every week"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/Calculator.jsx
msgid "Calculadora"
msgstr "Calculator"

#: src/components/Crew/CrewFields/CrewFields.jsx
#: src/components/Crew/CrewMembers/CrewMembers.jsx
#: src/pages/Economos/Movements/partials/EconomosListTabs/partials/EconomosListFields.jsx
#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/DeleteMovementWithRecurrenceConfirmation.jsx
#: src/pages/Items/tabs/Categories/HouseItemCategoryFields/HouseItemCategoryFields.jsx
#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
#: src/pages/Items/tabs/Items/partials/InitialSetupModal/InitialSetupModal.jsx
#: src/pages/Mementos/tabs/Mementos/partials/InitialSetupModal/InitialSetupModal.jsx
#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
#: src/pages/Mementos/tabs/MementosContributions/partials/ContributionFields/ContributionFields.jsx
#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
#: src/pages/Recipes/RecipeDetail.jsx
msgid "Cancelar"
msgstr "Cancel"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
#: src/pages/SplitExpenses/partials/SplitExpenseFields.jsx
msgid "Cantidad"
msgstr "Amount"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Cantidad inválida"
msgstr "Invalid amount"

#: src/pages/Items/tabs/Categories/Categories.jsx
msgid "Categoría eliminada con éxito"
msgstr "Category deleted successfully"

#: src/components/common/UsageLimit/usageUtils.jsx
msgid "Categorías"
msgstr "Categories"

#: src/pages/SplitExpenses/partials/SplitExpenseFields.jsx
msgid "Cena, taxi, super..."
msgstr "Dinner, taxi, groceries..."

#: src/pages/Login/LoginView.jsx
msgid "Cerrar"
msgstr "Close"

#: src/Layouts/private/PrivateLayout.jsx
msgid "Cerrar menú"
msgstr "Close menu"

#: src/components/common/ErrorBoundary/ErrorServer.jsx
msgid "Cerrar sesión"
msgstr "Sign out"

#: src/components/common/ErrorBoundary/ErrorFallback.jsx
msgid "Cerrar sesión y reparar"
msgstr "Sign out and repair"

#: src/pages/Mementos/TasksDashboard/partials/CompletedStatCard/CompletedStatCard.jsx
msgid "Completado hoy"
msgstr "Completed today"

#: src/pages/Mementos/tabs/Mementos/partials/MementoItem/MementoItem.jsx
msgid "Completar"
msgstr "Complete"

#: src/pages/Mementos/tabs/Mementos/partials/MementoItem/CompleteTaskAsModal.jsx
msgid "Completar tarea como:"
msgstr "Complete task as:"

#: src/pages/Settings/Settings.jsx
msgid "Completar tareas inactivas"
msgstr "Completing dormant tasks"

#: src/pages/Items/tabs/Items/partials/InitialSetupModal/InitialSetupModal.jsx
#: src/pages/Mementos/tabs/Mementos/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Con emojis"
msgstr "With emojis"

#: src/pages/SplitExpenses/partials/SplitExpenseFields.jsx
msgid "Concepto"
msgstr "Description"

#: src/pages/Items/tabs/Items/Items.jsx
#: src/pages/Items/tabs/Items/partials/EmptyItems/EmptyItems.jsx
#: src/pages/Items/tabs/Items/partials/InitialSetupModal/InitialSetupModal.jsx
#: src/pages/Mementos/tabs/Mementos/Mementos.jsx
#: src/pages/Mementos/tabs/Mementos/partials/InitialSetupModal/InitialSetupModal.jsx
#: src/pages/Mementos/TasksDashboard/TasksDashboard.jsx
msgid "Configuración inicial"
msgstr "Initial setup"

#: src/pages/Settings/Settings.jsx
msgid "Consentimiento de cookies"
msgstr "Cookie consent"

#: src/pages/Legal/PrivacyView.jsx
msgid "Conservamos tus datos mientras exista tu cuenta y, tras su eliminación, durante los plazos de prescripción legal aplicables. La prueba de consentimiento de cookies se conserva como máximo 12 meses desde la última decisión, o hasta que la retires."
msgstr "We keep your data while your account exists and, after deletion, for the applicable statutory limitation periods. The cookie consent proof is kept for a maximum of 12 months from your last decision, or until you withdraw it."

#: src/Layouts/private/partials/UserInfo.jsx
msgid "Contacto"
msgstr "Contact"

#: src/pages/Login/partials/EmailStep.jsx
#: src/pages/Login/partials/MagicLinkStep.jsx
msgid "Continuar"
msgstr "Continue"

#: src/pages/Mementos/tabs/MementosContributions/partials/ContributionFields/ContributionFields.jsx
msgid "Contribución editada"
msgstr "Contribution edited"

#: src/pages/Mementos/tabs/MementosContributions/partials/ContributionFields/ContributionFields.jsx
msgid "Contribución eliminada"
msgstr "Contribution deleted"

#: src/pages/Mementos/TasksDashboard/partials/TasksContributions/TasksContributions.jsx
msgid "Contribuciones"
msgstr "Contributions"

#: src/Layouts/private/partials/AppSelector.jsx
msgid "Controla tus finanzas domésticas. Registra ingresos, gastos y visualiza hábitos de consumo."
msgstr "Control your household finances. Track income, expenses, and visualize spending habits."

#: src/pages/Legal/CookiesView.jsx
msgid "Cookie"
msgstr "Cookie"

#: src/pages/Settings/Settings.jsx
msgid "Cookies"
msgstr "Cookies"

#: src/pages/Recipes/RecipeDetail.jsx
msgid "Copiado"
msgstr "Copied"

#: src/components/Crew/CrewMembers/CrewMembers.jsx
msgid "Copiar"
msgstr "Copy"

#: src/pages/Recipes/RecipeDetail.jsx
msgid "Copiar enlace"
msgstr "Copy link"

#: src/pages/Economos/Dashboard/EconomosMovementsDashboard.jsx
#: src/pages/Economos/Movements/EconomosMovementsView.jsx
msgid "Crea tu primera lista para empezar a registrar movimientos"
msgstr "Create your first list to start registering movements"

#: src/pages/Mementos/tabs/Mementos/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Creadas {created} de {total} tareas"
msgstr "Created {created} of {total} tasks"

#: src/pages/Items/tabs/Items/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Creados {created} de {total} ítems"
msgstr "Created {created} of {total} items"

#. placeholder {0}: progress.done
#. placeholder {1}: progress.total
#: src/pages/Items/tabs/Items/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Creando ítems... {0}/{1}"
msgstr "Creating items... {0}/{1}"

#. placeholder {0}: progress.done
#. placeholder {1}: progress.total
#: src/pages/Mementos/tabs/Mementos/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Creando tareas... {0}/{1}"
msgstr "Creating tasks... {0}/{1}"

#: src/utils/hooks/usePolymorphicData.jsx
msgid "Crear"
msgstr "Create"

#: src/pages/Items/tabs/Categories/HouseItemCategoryFields/HouseItemCategoryFields.jsx
msgid "Crear categoría"
msgstr "Create category"

#: src/pages/Home/HomeView.jsx
#: src/pages/Recipes/RecipeShareView.jsx
#: src/pages/Register/RegisterView.jsx
msgid "Crear cuenta"
msgstr "Create account"

#: src/components/Crew/CrewFields/CrewFields.jsx
#: src/Layouts/private/partials/CrewSelector.jsx
msgid "Crear espacio"
msgstr "Create workspace"

#: src/pages/SplitExpenses/partials/SplitExpenseGroupFields.jsx
msgid "Crear grupo de gastos"
msgstr "Create expense group"

#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
msgid "Crear ítem"
msgstr "Create item"

#: src/pages/Economos/Dashboard/EconomosMovementsDashboard.jsx
#: src/pages/Economos/Movements/EconomosMovementsView.jsx
#: src/pages/Economos/Movements/partials/EconomosListTabs/EconomosListTabs.jsx
#: src/pages/Economos/Movements/partials/EconomosListTabs/partials/EconomosListFields.jsx
msgid "Crear lista"
msgstr "Create list"

#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
msgid "Crear memento"
msgstr "Create task"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Crear movimiento"
msgstr "Create movement"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Crear receta"
msgstr "Create recipe"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Cualquiera con el enlace podrá ver esta receta"
msgstr "Anyone with the link will be able to see this recipe"

#: src/pages/Settings/Settings.jsx
msgid "Cuando se activen"
msgstr "When they activate"

#: src/pages/Legal/TermsView.jsx
msgid "Cuando se activen los pagos, los planes de pago se contratarán en euros (EUR) con IVA incluido cuando proceda, mostrando antes del pago el precio total y las características de cada plan. Como consumidor, dispondrás de 14 días naturales para desistir del contrato sin justificación, conforme al TRLGDCU. Esta sección entrará en vigor con la activación de los pagos."
msgstr "When payments are enabled, paid plans will be contracted in euros (EUR) with VAT included where applicable, showing the total price and the features of each plan before payment. As a consumer, you have 14 calendar days to withdraw from the contract without justification, in accordance with the TRLGDCU. This section will take effect when payments are activated."

#: src/pages/Register/RegisterView.jsx
msgid "Cuenta creada con éxito"
msgstr "Account created successfully"

#: src/pages/Login/LoginView.jsx
msgid "Cuenta no encontrada"
msgstr "Account not found"

#: src/pages/Legal/PrivacyView.jsx
msgid "Cumplir obligaciones legales y defender reclamaciones: interés legítimo y obligación legal (art. 6.1.c y 6.1.f RGPD)."
msgstr "Meeting legal obligations and defending claims: legitimate interest and legal obligation (Art. 6.1.c and 6.1.f GDPR)."

#: src/pages/Settings/Settings.jsx
msgid "Dashboard de tareas"
msgstr "Tasks dashboard"

#: src/pages/Legal/PrivacyView.jsx
msgid "Datos de cuenta: nombre de usuario, correo electrónico e idioma."
msgstr "Account data: username, email address and language."

#: src/pages/Legal/PrivacyView.jsx
msgid "Datos de diagnóstico: si aceptas las cookies no exentas, errores y rendimiento de la aplicación (Bugsnag), que pueden incluir tu identificador, correo y nombre de usuario."
msgstr "Diagnostic data: if you accept non-exempt cookies, application errors and performance (Bugsnag), which may include your identifier, email and username."

#: src/pages/Legal/PrivacyView.jsx
msgid "Datos de uso: los contenidos que creas (espacios, listas, tareas, movimientos) pertenecen a tu cuenta y a los espacios donde colaboras."
msgstr "Usage data: the content you create (workspaces, lists, tasks, movements) belongs to your account and to the workspaces where you collaborate."

#: src/pages/Legal/PrivacyView.jsx
msgid "Datos técnicos: registramos la prueba de consentimiento de cookies (identificador anónimo, fecha, versión de la política y decisión). No almacenamos IP ni User-Agent con ese registro."
msgstr "Technical data: we record the cookie consent proof (anonymous identifier, date, policy version and decision). We do not store IP or User-Agent with this record."

#: src/pages/Items/tabs/Predictions/Predictions.jsx
msgid "De esta forma, los ítems que actualmente estén con stock"
msgstr "This way, items currently in stock"

#: src/pages/SplitExpenses/partials/SplitExpenseFields.jsx
msgid "Debe ser mayor que 0"
msgstr "Must be greater than 0"

#: src/pages/Register/RegisterView.jsx
msgid "Debes aceptar los términos y la política de privacidad"
msgstr "You must accept the terms and the privacy policy"

#: src/pages/Legal/TermsView.jsx
msgid "Debes facilitar datos veraces y mantener la confidencialidad de tu cuenta. Eres responsable de la actividad realizada con ella. La mínima edad de uso es 14 años; los menores de 18 necesitan autorización de padre, madre o tutor legal."
msgstr "You must provide accurate information and keep your account confidential. You are responsible for the activity carried out with it. The minimum age of use is 14; minors under 18 need authorization from a parent or legal guardian."

#: src/pages/Mementos/tabs/Mementos/partials/MementoItem/MementoItem.jsx
msgid "Dentro de {parentDelayDays} {parentDelayDays, plural, one {día} other {días}}"
msgstr "In {parentDelayDays} {parentDelayDays, plural, one {day} other {days}}"

#: src/pages/Mementos/tabs/Mementos/partials/MementoItem/MementoItem.jsx
msgid "Desactivada"
msgstr "Deactivated"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Describe el paso"
msgstr "Describe the step"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Descripción"
msgstr "Description"

#: src/pages/Economos/Search/EconomosSearchView.jsx
msgid "Desde"
msgstr "From"

#: src/Layouts/private/partials/AppSelector.jsx
#: src/pages/Usage/UsageView.jsx
msgid "Despensa"
msgstr "Pantry"

#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
msgid "Destino"
msgstr "Destination"

#: src/pages/Economos/Dashboard/partials/DailyExpenseChart/DailyExpenseChart.jsx
msgid "Día {label}"
msgstr "Day {label}"

#: src/pages/Legal/PrivacyView.jsx
msgid "Diagnóstico de errores y rendimiento: tu consentimiento (art. 6.1.a RGPD), que puedes retirar en cualquier momento desde Ajustes."
msgstr "Error and performance diagnostics: your consent (Art. 6.1.a GDPR), which you can withdraw at any time from Settings."

#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
msgid "días"
msgstr "days"

#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
msgid "Días"
msgstr "Days"

#: src/Layouts/private/partials/AppSelector.jsx
#: src/pages/Usage/UsageView.jsx
msgid "Dinero"
msgstr "Money"

#: src/pages/SplitExpenses/partials/SplitExpenseFields.jsx
msgid "Dividido entre"
msgstr "Split among"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Duplicar"
msgstr "Duplicate"

#: src/pages/Legal/CookiesView.jsx
msgid "Duración"
msgstr "Duration"

#: src/pages/Recipes/RecipeDetail.jsx
msgid "Editar"
msgstr "Edit"

#: src/pages/Items/tabs/Categories/HouseItemCategoryFields/HouseItemCategoryFields.jsx
msgid "Editar categoría"
msgstr "Edit category"

#: src/pages/Mementos/tabs/MementosContributions/partials/ContributionFields/ContributionFields.jsx
#: src/pages/Mementos/tabs/MementosContributions/partials/ContributionItem/ContributionItem.jsx
msgid "Editar contribución"
msgstr "Edit contribution"

#: src/components/Crew/CrewFields/CrewFields.jsx
msgid "Editar espacio"
msgstr "Edit workspace"

#: src/pages/SplitExpenses/partials/SplitExpenseFields.jsx
msgid "Editar gasto"
msgstr "Edit expense"

#: src/pages/SplitExpenses/SplitExpensesView.jsx
msgid "Editar grupo"
msgstr "Edit group"

#: src/pages/SplitExpenses/partials/SplitExpenseGroupFields.jsx
msgid "Editar grupo de gastos"
msgstr "Edit expense group"

#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
#: src/pages/Items/tabs/Predictions/Predictions.jsx
msgid "Editar ítem"
msgstr "Edit item"

#: src/pages/Economos/Movements/partials/EconomosListTabs/partials/EconomosListFields.jsx
msgid "Editar lista"
msgstr "Edit list"

#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
msgid "Editar memento"
msgstr "Edit task"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Editar movimiento"
msgstr "Edit movement"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Editar receta"
msgstr "Edit recipe"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Editar serie"
msgstr "Edit series"

#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
msgid "Ej. Alquiler"
msgstr "e.g. Rent"

#: src/pages/MagicLink/MagicLink.jsx
msgid "El código no es válido o ha caducado."
msgstr "The code is not valid or has expired."

#: src/pages/CrewInvitation/CrewInvitationView.jsx
msgid "El enlace de invitación no es válido"
msgstr "The invitation link is not valid"

#: src/pages/Register/RegisterView.jsx
msgid "El nombre debe tener al menos 3 caracteres"
msgstr "Name must be at least 3 characters long"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "El nombre es obligatorio"
msgstr "Name is required"

#: src/pages/Register/RegisterView.jsx
msgid "El nombre no puede superar los 64 caracteres"
msgstr "Name cannot exceed 64 characters"

#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
msgid "El origen y el destino no pueden ser la misma lista"
msgstr "Origin and destination cannot be the same list"

#: src/pages/Legal/TermsView.jsx
msgid "El servicio se organiza en espacios que puedes compartir con otras personas. Al invitar a alguien a un espacio, su contenido será visible para sus miembros según el rol asignado. No uses el servicio para contenidos ilícitos, y respeta los derechos de terceros."
msgstr "The service is organized in workspaces that you can share with other people. When you invite someone to a workspace, its content will be visible to its members according to the assigned role. Do not use the service for unlawful content, and respect the rights of third parties."

#: src/pages/Items/tabs/Predictions/Predictions.jsx
msgid "El sistema de predicciones utiliza los ítems comprados en los últimos 6 meses y calcula el promedio de días que hay entre compra y compra."
msgstr "The prediction system uses items purchased in the last 6 months and calculates the average days between purchases."

#: src/pages/Settings/Settings.jsx
msgid "Elige si el dashboard de tareas muestra las de todos tus espacios o sólo las del seleccionado."
msgstr "Choose if the task dashboard shows those of all your spaces or only those of the selected one."

#: src/pages/Economos/Movements/partials/EconomosListTabs/partials/EconomosListFields.jsx
#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/DeleteMovementWithRecurrenceConfirmation.jsx
#: src/pages/Mementos/tabs/MementosContributions/partials/ContributionFields/ContributionFields.jsx
#: src/pages/Recipes/RecipeDetail.jsx
msgid "Eliminar"
msgstr "Delete"

#: src/pages/Items/tabs/Categories/HouseItemCategoryFields/HouseItemCategoryFields.jsx
msgid "Eliminar categoría"
msgstr "Delete category"

#: src/pages/Mementos/tabs/MementosContributions/partials/ContributionFields/ContributionFields.jsx
msgid "Eliminar contribución"
msgstr "Delete contribution"

#: src/components/Crew/CrewFields/CrewFields.jsx
msgid "Eliminar crew"
msgstr "Delete workspace"

#: src/components/Crew/CrewFields/CrewFields.jsx
msgid "Eliminar espacio"
msgstr "Delete workspace"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Eliminar este y los siguientes"
msgstr "Delete this and the following"

#: src/pages/SplitExpenses/partials/SplitExpenseFields.jsx
msgid "Eliminar gasto"
msgstr "Delete expense"

#: src/pages/SplitExpenses/partials/SplitExpenseGroupFields.jsx
msgid "Eliminar grupo"
msgstr "Delete group"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Eliminar ingrediente"
msgstr "Delete ingredient"

#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
msgid "Eliminar ítem"
msgstr "Delete item"

#: src/pages/Economos/Movements/partials/EconomosListTabs/partials/EconomosListFields.jsx
msgid "Eliminar lista"
msgstr "Delete list"

#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
msgid "Eliminar memento"
msgstr "Delete task"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Eliminar movimiento"
msgstr "Delete movement"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/DeleteMovementWithRecurrenceConfirmation.jsx
msgid "Eliminar movimiento recurrente"
msgstr "Delete recurring movement"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Eliminar movimientos"
msgstr "Delete movements"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Eliminar paso"
msgstr "Delete step"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
#: src/pages/Recipes/RecipeDetail.jsx
msgid "Eliminar receta"
msgstr "Delete recipe"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Eliminar serie"
msgstr "Delete series"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Eliminar serie de movimientos"
msgstr "Delete movement series"

#: src/components/common/ui/input/EmailInput.jsx
msgid "Email"
msgstr "Email"

#: src/pages/Login/partials/EmailStep.jsx
#: src/pages/Register/RegisterView.jsx
msgid "Email inválido"
msgstr "Invalid email"

#: src/pages/Login/LoginView.jsx
msgid "Email reenviado"
msgstr "Email resent"

#: src/components/common/ui/input/EmailInput.jsx
msgid "email@dominio.com"
msgstr "email@domain.com"

#: src/components/common/ui/dates/Datepicker.jsx
msgid "En 1 año"
msgstr "In 1 year"

#: src/components/common/ui/dates/Datepicker.jsx
msgid "En 1 mes"
msgstr "In 1 month"

#: src/components/common/ui/dates/Datepicker.jsx
msgid "En 3 meses"
msgstr "In 3 months"

#: src/components/common/ui/dates/Datepicker.jsx
msgid "En 6 meses"
msgstr "In 6 months"

#: src/pages/Settings/Settings.jsx
msgid "En versión móvil mostrará el selector de espacios en la parte superior en todo momento."
msgstr "In the mobile version the workspace selector will be displayed at the top at all times."

#: src/components/Crew/CrewMembers/CrewMembers.jsx
msgid "Enlace de invitación"
msgstr "Invitation link"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Enlace público"
msgstr "Public link"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Entre 1 y 99 raciones"
msgstr "Between 1 and 99 servings"

#: src/components/Crew/CrewMembers/CrewMembers.jsx
#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
#: src/utils/common/api/handleApiResponse.jsx
msgid "Error"
msgstr "Error"

#: src/pages/Usage/UsageView.jsx
msgid "Error al cargar el uso."
msgstr "Error loading usage."

#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
msgid "Error al crear la transferencia"
msgstr "Error creating transfer"

#: src/pages/CrewInvitation/CrewInvitationView.jsx
msgid "Error desconocido"
msgstr "Unknown error"

#: src/pages/Recipes/RecipeDetail.jsx
#: src/pages/Recipes/RecipeShareView.jsx
msgid "Escalar cantidades"
msgstr "Scale quantities"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/TagsSelector.jsx
msgid "Escribe aquí las etiquetas"
msgstr "Type tags here"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Escribe el nombre o enlaza un ítem"
msgstr "Type a name or link an item"

#: src/components/common/ui/combobox/ComboboxBase/ComboboxBase.jsx
#: src/pages/Items/tabs/Categories/Categories.jsx
#: src/pages/Items/tabs/Items/Items.jsx
#: src/pages/Recipes/RecipesView.jsx
msgid "Escribe para buscar"
msgstr "Type to search"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
#: src/pages/Economos/Search/EconomosSearchView.jsx
#: src/pages/SplitExpenses/partials/SplitExpenseGroupFields.jsx
msgid "Escribe un nombre"
msgstr "Type a name"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
msgid "Escribe una descripción"
msgstr "Type a description"

#: src/components/common/ui/datadisplay/Effort.jsx
msgid "esfuerzo"
msgstr "effort"

#: src/components/common/ui/datadisplay/Effort.jsx
#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
msgid "Esfuerzo"
msgstr "Effort"

#: src/pages/Mementos/TasksDashboard/partials/TasksContributions/TasksContributions.jsx
msgid "Esfuerzo completado esta semana en el espacio seleccionado"
msgstr "Effort completed this week in the selected space"

#: src/Layouts/private/partials/CrewSelector.jsx
msgid "Espacio creado con éxito"
msgstr "Workspace created successfully"

#: src/Layouts/private/partials/CrewSelector.jsx
msgid "Espacio eliminado con éxito"
msgstr "Workspace deleted successfully"

#: src/pages/SplitExpenses/SplitExpensesView.jsx
msgid "Espacio no encontrado"
msgstr "Workspace not found"

#: src/Layouts/private/partials/CrewSelector.jsx
msgid "Espacio renombrado con éxito"
msgstr "Workspace renamed successfully"

#: src/components/common/UsageLimit/usageUtils.jsx
#: src/Layouts/private/partials/CrewSelector.jsx
msgid "Espacios"
msgstr "Workspaces"

#. placeholder {0}: crew.name
#. placeholder {0}: houseItem.name
#. placeholder {0}: memento.name
#: src/components/Crew/CrewFields/CrewFields.jsx
#: src/pages/Items/tabs/Categories/HouseItemCategoryFields/HouseItemCategoryFields.jsx
#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
#: src/pages/Recipes/RecipeDetail.jsx
msgid "Esta acción eliminará \"{0}\" de forma permanente y no se podrá recuperar la información."
msgstr "This action will permanently delete \"{0}\" and the information cannot be recovered."

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Esta acción eliminará el movimiento de forma permanente y no se podrá recuperar la información."
msgstr "This action will permanently delete the movement and the information cannot be recovered."

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Esta acción eliminará este movimiento y todos los siguientes de la serie de forma permanente y no se podrá recuperar la información."
msgstr "This action will permanently delete this movement and all following in the series, and the information cannot be recovered."

#: src/pages/Mementos/tabs/MementosContributions/partials/ContributionFields/ContributionFields.jsx
msgid "Esta acción eliminará la contribución de forma permanente y no se podrá recuperar la información."
msgstr "This action will permanently delete the contribution and the information cannot be recovered."

#: src/pages/Economos/Movements/partials/EconomosListTabs/partials/EconomosListFields.jsx
msgid "Esta acción eliminará la lista y TODOS su movimientos de forma permanente y no se podrá recuperar la información."
msgstr "This action will permanently delete the list and ALL its movements, and the information cannot be recovered."

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Esta acción eliminará todos los movimientos de la serie de forma permanente y no se podrá recuperar la información."
msgstr "This action will permanently delete all movements in the series, and the information cannot be recovered."

#. placeholder {0}: user.username
#. placeholder {1}: crew.name
#: src/components/Crew/CrewMembers/CrewMembers.jsx
msgid "Esta acción expulsará a <0>{0}</0> de tu espacio <1>{1}</1>.<2/>Podrás volver a enviarle un enlace de invitación para que vuelva a unirse."
msgstr "This action will remove <0>{0}</0> from your workspace <1>{1}</1>.<2/>You can send them a new invitation link to rejoin."

#: src/components/Crew/CrewMembers/CrewMembers.jsx
msgid "Esta acción invalidará el enlace de invitación actual y creará uno nuevo. Todas las invitaciones enviadas y no aceptadas, dejarán de funcionar."
msgstr "This action will invalidate the current invitation link and create a new one. All sent and unaccepted invitations will stop working."

#: src/pages/Recipes/RecipeDetail.jsx
msgid "Esta receta es privada"
msgstr "This recipe is private"

#: src/pages/Recipes/RecipeDetail.jsx
msgid "Esta receta es pública"
msgstr "This recipe is public"

#: src/pages/Mementos/tabs/Mementos/Mementos.jsx
#: src/pages/Mementos/TasksDashboard/partials/TasksContributions/TasksContributions.jsx
msgid "Esta semana"
msgstr "This week"

#: src/pages/Economos/Search/EconomosSearchView.jsx
msgid "Estadísticas"
msgstr "Statistics"

#: src/pages/Settings/Settings.jsx
msgid "Estado actual: {consentStatus}. Puedes reabrir el aviso de cookies para cambiar tu decisión en cualquier momento."
msgstr "Current status: {consentStatus}. You can reopen the cookie notice to change your decision at any time."

#: src/pages/Economos/Search/partials/DaterangeShortcuts/DaterangeShortcuts.jsx
msgid "Este año"
msgstr "This year"

#: src/components/Crew/CrewFields/CrewFields.jsx
msgid "Este campo es obligatorio"
msgstr "This field is required"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/DeleteMovementWithRecurrenceConfirmation.jsx
msgid "Este y los siguientes"
msgstr "This and the following"

#: src/pages/Legal/TermsView.jsx
msgid "Estos términos regulan el acceso y uso de la aplicación (en adelante, \"el servicio\"), prestada por [PENDIENTE: razón social, NIF y domicilio del titular]. Registrarte implica aceptarlos."
msgstr "These terms govern access to and use of the application (hereinafter, \"the service\"), provided by [PENDING: company name, tax ID and registered address of the owner]. By registering, you accept them."

#: src/pages/Legal/TermsView.jsx
msgid "Estos términos se rigen por la legislación española. Para consumidores, será competente la jurisdicción de su domicilio. Para otras cuestiones, ver nuestra <0>política de privacidad</0>."
msgstr "These terms are governed by Spanish law. For consumers, the courts of their place of residence shall have jurisdiction. For other matters, see our <0>privacy policy</0>."

#: src/pages/Economos/Movements/partials/EconomosListTabs/partials/EconomosListFields.jsx
msgid "Etiqueta que indica el inicio del mes"
msgstr "Tag that marks the start of the month"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/TagsSelector.jsx
msgid "Etiquetas"
msgstr "Tags"

#: src/pages/Economos/Dashboard/partials/CommonExpenses/CommonExpenses.jsx
msgid "Etiquetas relevantes"
msgstr "Relevant tags"

#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "Evolución"
msgstr "Evolution"

#: src/Layouts/private/partials/AppSelector.jsx
#: src/pages/Dashboard/DashboardView.jsx
#: src/pages/Usage/UsageView.jsx
msgid "Experimentos"
msgstr "Experiments"

#: src/components/Crew/CrewMembers/partials/CrewMember/CrewMember.jsx
msgid "Expulsar"
msgstr "Remove"

#: src/components/Crew/CrewMembers/CrewMembers.jsx
msgid "Expulsar miembro"
msgstr "Remove member"

#: src/components/common/ui/dates/Datepicker.jsx
msgid "Fecha"
msgstr "Date"

#: src/pages/Legal/CookiesView.jsx
msgid "Finalidad"
msgstr "Purpose"

#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
msgid "Frecuencia (días)"
msgstr "Frequency (days)"

#: src/pages/Economos/Dashboard/partials/DailyExpenseChart/DailyExpenseChart.jsx
msgid "Gasto acumulado"
msgstr "Accumulated expense"

#: src/pages/Economos/Dashboard/partials/DailyExpenseCard.jsx
msgid "Gasto hasta ahora"
msgstr "Spent so far"

#: src/pages/Economos/Dashboard/partials/DailyExpenseCard.jsx
msgid "Gasto total del mes"
msgstr "Total monthly expense"

#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
#: src/pages/SplitExpenses/SplitExpensesView.jsx
msgid "Gastos"
msgstr "Expenses"

#: src/Layouts/private/partials/AppSelector.jsx
msgid "Gastos compartidos"
msgstr "Shared expenses"

#: src/pages/Economos/Movements/partials/EconomosMonthBalance/EconomosMonthBalance.jsx
msgid "Gastos:"
msgstr "Expenses:"

#: src/pages/Usage/UsageView.jsx
msgid "General"
msgstr "General"

#: src/Layouts/private/partials/AppSelector.jsx
msgid "Gestiona tu despensa. Lleva inventario de productos y genera listas de compra automáticamente."
msgstr "Manage your pantry. Keep inventory of products and automatically generate shopping lists."

#: src/pages/Settings/Settings.jsx
msgid "Gestionar cookies"
msgstr "Manage cookies"

#: src/components/Crew/CrewFields/CrewFields.jsx
msgid "Gestionar miembros"
msgstr "Manage members"

#: src/components/Crew/CrewMembers/CrewMembers.jsx
msgid "Gestionar miembros del espacio"
msgstr "Manage workspace members"

#: src/pages/Items/tabs/Predictions/Predictions.jsx
msgid "Gracias"
msgstr "Thanks"

#: src/pages/Home/HomeView.jsx
msgid "Gratis, sin contraseña y listo en 10 segundos."
msgstr "Free, no password, and ready in 10 seconds."

#: src/Layouts/private/partials/AppSelector.jsx
msgid "Guarda tus recetas y tenlas siempre a mano cuando cocines."
msgstr "Save your recipes and keep them at hand whenever you cook."

#: src/pages/Legal/CookiesView.jsx
msgid "Guardamos en el almacenamiento local de tu navegador datos técnicos necesarios para la app (preferencias de interfaz, idioma, espacio seleccionado, prueba de tu consentimiento y un identificador anónimo de visitante). No se comparten con terceros."
msgstr "We store in your browser's local storage technical data needed for the app (interface preferences, language, selected workspace, your consent proof and an anonymous visitor identifier). They are not shared with third parties."

#: src/utils/hooks/usePolymorphicData.jsx
msgid "Guardar"
msgstr "Save"

#: src/utils/common/api/handleApiResponse.jsx
msgid "Ha ocurrido un error desconocido"
msgstr "An unknown error has occurred"

#: src/components/common/ErrorBoundary/ErrorFallback.jsx
msgid "Ha ocurrido un error inesperado"
msgstr "An unexpected error has occurred"

#: src/pages/Mementos/tabs/Mementos/partials/MementoItem/MementoItem.jsx
msgid "Hace {delayDays} {delayDays, plural, one {día} other {días}}"
msgstr "{delayDays} {delayDays, plural, one {day} other {days}} ago"

#. placeholder {0}: item.used
#. placeholder {1}: item.limit
#: src/components/common/UsageLimit/UsageLimit.jsx
msgid "Has usado {0} de {1} en total"
msgstr "You've used {0} of {1} in total"

#. placeholder {0}: item.used
#. placeholder {1}: item.limit
#: src/components/common/UsageLimit/UsageLimit.jsx
msgid "Has usado {0} de {1} este mes"
msgstr "You've used {0} of {1} this month"

#: src/pages/Economos/Search/EconomosSearchView.jsx
msgid "Hasta"
msgstr "To"

#: src/pages/Login/partials/MagicLinkStep.jsx
msgid "Hemos enviado un enlace temporal para iniciar sesión.<0/>Por favor, revisa la bandeja de entrada de <1>{email}</1>.<2/>Caduca en 2 minutos."
msgstr "We've sent you a temporary link to sign in.<0/>Please check the inbox of <1>{email}</1>.<2/>It expires in 2 minutes."

#: src/pages/Repair/RepairView.jsx
msgid "Herramienta de reparación"
msgstr "Repair tool"

#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Horas"
msgstr "Hours"

#: src/components/common/ui/dates/Datepicker.jsx
#: src/pages/Economos/Search/partials/DaterangeShortcuts/DaterangeShortcuts.jsx
#: src/pages/Mementos/tabs/Mementos/Mementos.jsx
#: src/pages/Mementos/tabs/Mementos/partials/MementoItem/MementoItem.jsx
#: src/pages/Mementos/TasksDashboard/TasksDashboard.jsx
msgid "Hoy"
msgstr "Today"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Indica el tiempo"
msgstr "Set the time"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Indica la unidad"
msgstr "Set the unit"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Ingrediente"
msgstr "Ingredient"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Ingredientes"
msgstr "Ingredients"

#: src/pages/Recipes/RecipeDetail.jsx
#: src/pages/Recipes/RecipeShareView.jsx
msgid "Ingredientes para"
msgstr "Ingredients for"

#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "Ingresos"
msgstr "Income"

#: src/pages/Economos/Movements/partials/EconomosMonthBalance/EconomosMonthBalance.jsx
msgid "Ingresos:"
msgstr "Income:"

#: src/Layouts/private/partials/AppSelector.jsx
msgid "Inicio"
msgstr "Home"

#: src/pages/Settings/Settings.jsx
msgid "Interfaz"
msgstr "Interface"

#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
msgid "Introduce un importe mayor que 0"
msgstr "Enter an amount greater than 0"

#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
msgid "Introduce un nombre"
msgstr "Enter a name"

#: src/pages/Login/partials/MagicLinkStep.jsx
msgid "Introducir código manualmente"
msgstr "Enter code manually"

#: src/pages/CrewInvitation/CrewInvitationView.jsx
msgid "Invitación a espacio"
msgstr "Workspace invitation"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Ítem de despensa (opcional)"
msgstr "Pantry item (optional)"

#: src/pages/Recipes/RecipeDetail.jsx
#: src/pages/Recipes/RecipeShareView.jsx
msgid "Ítem eliminado"
msgstr "Item deleted"

#: src/components/common/UsageLimit/usageUtils.jsx
msgid "Ítems"
msgstr "Items"

#: src/pages/Items/tabs/Items/Items.jsx
msgid "La compra ha sido registrada con éxito"
msgstr "The purchase has been successfully recorded"

#. placeholder {0}: _pred?.daysSinceMostRecentEvent ?? "¿?"
#: src/pages/Items/tabs/Predictions/Predictions.jsx
msgid "La última compra fue hace {0} días."
msgstr "The last purchase was {0} days ago."

#: src/pages/Legal/CookiesView.jsx
msgid "Las cookies son pequeños archivos que se guardan en tu navegador. Usamos cookies técnicas estrictamente necesarias para que la aplicación funcione, que no requieren consentimiento según el art. 22.2 LSSI, y una cookie no exenta (diagnóstico de errores) que solo se activa si la aceptas."
msgstr "Cookies are small files stored in your browser. We use strictly necessary technical cookies for the application to work, which do not require consent under Art. 22.2 of the Spanish Information Society Services Act (LSSI), and one non-exempt cookie (error diagnostics) that is only enabled if you accept it."

#: src/pages/Items/tabs/Items/partials/HouseItem/partials/Stock.jsx
#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
msgid "Limitado"
msgstr "Limited"

#: src/pages/Economos/Search/EconomosSearchView.jsx
msgid "Limpiar"
msgstr "Clear"

#: src/components/common/ui/combobox/HouseItemCombobox.jsx
msgid "Limpiar valor"
msgstr "Clear value"

#: src/pages/Mementos/tabs/Mementos/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Limpieza"
msgstr "Cleaning"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
#: src/pages/Economos/Search/EconomosSearchView.jsx
msgid "Lista"
msgstr "List"

#: src/pages/Economos/Movements/partials/EconomosDateSelector/EconomosDateSelector.jsx
msgid "Lista de meses"
msgstr "Month list"

#: src/components/common/UsageLimit/usageUtils.jsx
msgid "Listas de dinero"
msgstr "Money lists"

#: src/pages/SplitExpenses/SplitExpensesGroupView.jsx
msgid "Los grupos sin actividad durante 14 días se eliminarán automáticamente."
msgstr "Groups without activity for 14 days will be automatically deleted."

#: src/components/common/ui/dates/Datepicker.jsx
msgid "Mañana"
msgstr "Tomorrow"

#: src/pages/Legal/CookiesView.jsx
msgid "Mantener tu sesión iniciada de forma segura."
msgstr "Keep you securely logged in."

#: src/pages/Legal/TermsView.jsx
msgid "Mantienes la propiedad de los contenidos que creas. Te concedemos una licencia limitada para usar el servicio conforme a estos términos. La marca, el software y el diseño del servicio son propiedad del titular o de sus licenciantes."
msgstr "You keep ownership of the content you create. We grant you a limited license to use the service in accordance with these terms. The brand, software and design of the service are owned by the owner or its licensors."

#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
msgid "Marcar como agotado tras"
msgstr "Mark as out of stock after"

#: src/pages/Items/tabs/Predictions/Predictions.jsx
msgid "Marcar como:"
msgstr "Mark as:"

#: src/pages/Economos/Search/EconomosSearchView.jsx
msgid "Más info"
msgstr "More info"

#: src/pages/Mementos/tabs/Mementos/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Mascotas y plantas"
msgstr "Pets & plants"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Máximo 48 horas"
msgstr "Maximum 48 hours"

#: src/pages/Economos/Search/EconomosSearchView.jsx
msgid "Mayor gasto"
msgstr "Highest expense"

#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "Media al mes"
msgstr "Average per month"

#: src/pages/Economos/Search/EconomosSearchView.jsx
msgid "Media diaria"
msgstr "Daily average"

#: src/pages/Economos/Search/EconomosSearchView.jsx
msgid "Media mensual"
msgstr "Monthly average"

#: src/pages/Economos/Search/EconomosSearchView.jsx
msgid "Media por movimiento"
msgstr "Average per movement"

#: src/pages/Usage/UsageView.jsx
msgid "Mejora a <0/> para aumentar tus límites."
msgstr "Upgrade to <0/> to increase your limits."

#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "Mensual"
msgstr "Monthly"

#: src/pages/Economos/Dashboard/partials/CommonExpenses/CommonExpenses.jsx
#: src/pages/Economos/Dashboard/partials/DailyExpenseChart/DailyExpenseChart.jsx
msgid "Mes actual"
msgstr "Current month"

#: src/pages/Economos/Dashboard/partials/CommonExpenses/CommonExpenses.jsx
#: src/pages/Economos/Dashboard/partials/DailyExpenseChart/DailyExpenseChart.jsx
msgid "Mes anterior"
msgstr "Previous month"

#: src/components/Crew/CrewMembers/partials/CrewMember/CrewMember.jsx
msgid "Miembro"
msgstr "Member"

#: src/components/Crew/CrewMembers/CrewMembers.jsx
msgid "Miembro expulsado con éxito"
msgstr "Member removed successfully"

#: src/components/common/UsageLimit/usageUtils.jsx
#: src/components/Crew/CrewMembers/CrewMembers.jsx
msgid "Miembros"
msgstr "Members"

#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Minutos"
msgstr "Minutes"

#: src/pages/Items/tabs/Items/Items.jsx
#: src/pages/Items/tabs/Items/partials/HouseItem/partials/StockPopover/StockPopover.jsx
msgid "Modo compra"
msgstr "Shopping mode"

#: src/Layouts/private/partials/AppSelector.jsx
msgid "Módulos"
msgstr "Modules"

#. placeholder {0}: filteredHouseCategories.length
#. placeholder {0}: filteredHouseItems.length
#. placeholder {1}: houseCategories.length
#. placeholder {1}: houseItems.length
#: src/pages/Items/tabs/Categories/Categories.jsx
#: src/pages/Items/tabs/Items/Items.jsx
msgid "Mostrando {0} de {1} resultados"
msgstr "Showing {0} of {1} results"

#: src/pages/Settings/Settings.jsx
msgid "Mostrar"
msgstr "Show"

#: src/pages/Settings/Settings.jsx
msgid "Mostrar a la derecha"
msgstr "Show on the right"

#: src/pages/Settings/Settings.jsx
msgid "Mostrar a la izquierda"
msgstr "Show on the left"

#: src/pages/Economos/Movements/partials/EconomosSummaryByTags/EconomosSummaryByTags.jsx
msgid "Mostrar ingresos"
msgstr "Show income"

#: src/pages/Items/tabs/Items/Items.jsx
msgid "Mostrar ítems con stock limitado"
msgstr "Show items with limited stock"

#: src/pages/Settings/Settings.jsx
msgid "Mostrará un botón como este <0/> en la esquina inferior de la pantalla, para abrir el menú lateral de forma más fácil con el dedo pulgar."
msgstr "It will show a button like this <0/> in the bottom corner of the screen, to open the side menu more easily with your thumb."

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Movimiento duplicado"
msgstr "Movement duplicated"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Movimiento editado"
msgstr "Movement edited"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Movimiento eliminado"
msgstr "Movement deleted"

#: src/pages/Economos/Movements/partials/EconomosItem/EconomosItem.jsx
msgid "Movimiento recurrente"
msgstr "Recurring movement"

#: src/pages/Economos/Movements/partials/EconomosApps/EconomosApps.jsx
#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "Movimientos"
msgstr "Movements"

#: src/components/common/UsageLimit/usageUtils.jsx
msgid "Movimientos / mes"
msgstr "Movements / month"

#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "Movimientos al mes"
msgstr "Movements per month"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Movimientos eliminados"
msgstr "Movements deleted"

#: src/pages/Onboarding/GroupView.jsx
msgid "Muéstrame cómo"
msgstr "Show me how"

#: src/components/common/ui/combobox/HouseItemCombobox.jsx
msgid "Nada encontrado"
msgstr "Nothing found"

#: src/components/common/ui/combobox/ComboboxBase/ComboboxBase.jsx
msgid "Nada seleccionado"
msgstr "Nothing selected"

#: src/App.jsx
msgid "Necesitas iniciar sesión"
msgstr "You need to sign in"

#: src/pages/Items/tabs/Categories/HouseItemCategory/HouseItemCategory.jsx
msgid "Ningún ítem la usa"
msgstr "No item uses it"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/Recommendations.jsx
msgid "No hay recomendaciones"
msgstr "No recommendations"

#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
msgid "No hay tareas disponibles"
msgstr "No tasks available"

#: src/pages/Economos/Movements/partials/EconomosRecurrenceSelector/EconomosRecurrenceSelector.jsx
msgid "No repetir"
msgstr "Don't repeat"

#: src/pages/Economos/Search/EconomosSearchView.jsx
msgid "No se encontraron resultados"
msgstr "No results found"

#: src/pages/Recipes/RecipesView.jsx
msgid "No se han encontrado recetas"
msgstr "No recipes found"

#: src/pages/Register/RegisterView.jsx
msgid "No se permite un email desechable"
msgstr "Disposable email addresses are not allowed"

#: src/components/common/ErrorBoundary/ErrorServer.jsx
msgid "No se puede conectar con el servidor"
msgstr "Cannot connect to the server"

#: src/utils/common/api/handleApiResponse.jsx
msgid "No tienes permisos para realizar esta acción"
msgstr "You don't have permission to perform this action"

#: src/components/Crew/CrewFields/CrewFields.jsx
#: src/pages/Economos/Movements/partials/EconomosListTabs/partials/EconomosListFields.jsx
#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
#: src/pages/Economos/Search/EconomosSearchView.jsx
#: src/pages/Items/tabs/Categories/HouseItemCategoryFields/HouseItemCategoryFields.jsx
#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
#: src/pages/SplitExpenses/partials/SplitExpenseGroupFields.jsx
msgid "Nombre"
msgstr "Name"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Nombre de la receta"
msgstr "Recipe name"

#: src/pages/Register/RegisterView.jsx
msgid "Nombre de usuario"
msgstr "Username"

#: src/components/Crew/CrewFields/CrewFields.jsx
msgid "Nombre del espacio"
msgstr "Workspace name"

#: src/pages/Items/tabs/Categories/HouseItemCategoryFields/HouseItemCategoryFields.jsx
#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
msgid "Nombre del ítem"
msgstr "Item name"

#: src/pages/SplitExpenses/partials/SplitExpenseFields.jsx
#: src/pages/SplitExpenses/partials/SplitExpenseGroupFields.jsx
msgid "Nombre requerido"
msgstr "Name required"

#: src/pages/Items/tabs/Categories/Categories.jsx
msgid "Nueva categoría"
msgstr "New category"

#: src/pages/Recipes/RecipesView.jsx
msgid "Nueva receta"
msgstr "New recipe"

#: src/pages/Mementos/tabs/Mementos/Mementos.jsx
msgid "Nueva tarea"
msgstr "New task"

#: src/components/common/ui/badge/NewBadge.jsx
msgid "Nuevo"
msgstr "New"

#: src/pages/SplitExpenses/partials/SplitExpenseFields.jsx
#: src/pages/SplitExpenses/SplitExpensesView.jsx
msgid "Nuevo gasto"
msgstr "New expense"

#: src/pages/SplitExpenses/SplitExpensesGroupView.jsx
msgid "Nuevo grupo"
msgstr "New group"

#: src/pages/Items/tabs/Items/Items.jsx
msgid "Nuevo ítem"
msgstr "New item"

#: src/pages/Economos/Dashboard/EconomosMovementsDashboard.jsx
#: src/pages/Economos/Movements/EconomosMovementsView.jsx
msgid "Nuevo movimiento"
msgstr "New movement"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Nuevo movimiento creado"
msgstr "New movement created"

#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
msgid "Nunca"
msgstr "Never"

#: src/pages/Items/tabs/Predictions/Predictions.jsx
msgid "o"
msgstr "or"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/Recommendations.jsx
#: src/pages/Settings/Settings.jsx
msgid "Ocultar"
msgstr "Hide"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/Calculator.jsx
msgid "Operación:"
msgstr "Operation:"

#: src/pages/Economos/Movements/partials/EconomosListTabs/partials/EconomosListFields.jsx
msgid "Orden"
msgstr "Order"

#: src/Layouts/private/partials/AppSelector.jsx
msgid "Organiza tus tareas del hogar. Crea listas, establece prioridades y nunca olvides lo que necesitas hacer."
msgstr "Organize your household tasks. Create lists, set priorities, and never forget what you need to do."

#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
msgid "Origen"
msgstr "Origin"

#: src/pages/Mementos/tabs/Mementos/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Otros"
msgstr "Other"

#: src/pages/SplitExpenses/partials/SplitExpenseFields.jsx
msgid "Pagado por"
msgstr "Paid by"

#. placeholder {0}: expense.paidBy
#: src/pages/SplitExpenses/SplitExpensesView.jsx
msgid "Pagado por <0>{0}</0>"
msgstr "Paid by <0>{0}</0>"

#: src/pages/SplitExpenses/SplitExpensesView.jsx
msgid "pagó"
msgstr "paid"

#: src/pages/Onboarding/GroupView.jsx
msgid "para crear un espacio"
msgstr "to create a workspace"

#: src/pages/Items/tabs/Predictions/Predictions.jsx
msgid "Para que un ítem desaparezca de esta lista, tendrás que marcarlo como"
msgstr "For an item to disappear from this list, you'll need to mark it as"

#: src/pages/Recipes/partials/RecipeSteps/RecipeSteps.jsx
msgid "Paso"
msgstr "Step"

#. placeholder {0}: i + 1
#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Paso {0}"
msgstr "Step {0}"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Pasos"
msgstr "Steps"

#: src/pages/Register/RegisterView.jsx
msgid "pepeking66"
msgstr "pepeking66"

#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "Periodo"
msgstr "Period"

#. placeholder {0}: item?.extendedProps?.recurrenceShortId
#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Pertenece a la serie: {0}"
msgstr "Belongs to series: {0}"

#: src/Layouts/private/partials/UserInfo.jsx
msgid "Plan:"
msgstr "Plan:"

#: src/pages/Legal/TermsView.jsx
msgid "Podemos actualizar estos términos notificándotelo con antelación razonable; si continúas usando el servicio, se entienden aceptados. Puedes dejar de usar el servicio y eliminar tu cuenta en cualquier momento."
msgstr "We may update these terms by notifying you in advance; if you continue using the service, they are considered accepted. You can stop using the service and delete your account at any time."

#: src/pages/Mementos/tabs/Mementos/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Podrás crear nuevas tareas personalizadas en cualquier momento"
msgstr "You can create new custom tasks at any time"

#: src/pages/Items/tabs/Items/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Podrás crear nuevos ítems personalizados en cualquier momento"
msgstr "You can create new custom items at any time"

#: src/pages/Legal/CookiesView.jsx
msgid "Política de cookies"
msgstr "Cookie policy"

#: src/pages/Legal/PrivacyView.jsx
msgid "Política de privacidad"
msgstr "Privacy policy"

#: src/pages/Economos/Movements/partials/EconomosListTabs/partials/EconomosListFields.jsx
msgid "Por ejemplo: \"sueldo\""
msgstr "For example: \"salary\""

#: src/pages/Economos/Dashboard/partials/DailyExpenseChart/DailyExpenseChart.jsx
msgid "Predicción"
msgstr "Prediction"

#: src/pages/Economos/Dashboard/partials/DailyExpenseCard.jsx
msgid "Predicción de gasto total"
msgstr "Total expense prediction"

#: src/pages/Items/tabs/Predictions/Predictions.jsx
msgid "Predicciones"
msgstr "Predictions"

#: src/pages/Economos/Movements/partials/EconomosDateSelector/EconomosDateSelector.jsx
msgid "Presente"
msgstr "Present"

#: src/pages/Legal/PrivacyView.jsx
msgid "Prestar el servicio y gestionar tu cuenta: ejecución del contrato (art. 6.1.b RGPD)."
msgstr "Providing the service and managing your account: performance of the contract (Art. 6.1.b GDPR)."

#: src/pages/Legal/CookiesView.jsx
msgid "Prevenir ataques CSRF al enviar formularios."
msgstr "Prevent CSRF attacks when submitting forms."

#: src/pages/Onboarding/GroupView.jsx
msgid "Primero necesitas crear un espacio"
msgstr "You need to create a workspace first"

#: src/pages/Usage/UsageView.jsx
msgid "Primero selecciona un espacio."
msgstr "First select a workspace."

#: src/pages/Items/tabs/Items/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Productos del día a día"
msgstr "Everyday products"

#: src/components/Crew/CrewMembers/partials/CrewMember/CrewMember.jsx
msgid "Propietario"
msgstr "Owner"

#: src/pages/Economos/Dashboard/partials/DailyExpenseCard.jsx
msgid "Proyección de gasto del mes"
msgstr "Monthly expense projection"

#: src/pages/Legal/CookiesView.jsx
msgid "Puedes aceptar o rechazar en el aviso que aparece al entrar, con ambas opciones igual de accesibles."
msgstr "You can accept or reject in the notice shown on entry, with both options equally accessible."

#: src/pages/Legal/CookiesView.jsx
msgid "Puedes cambiar tu decisión en cualquier momento desde Ajustes → Cookies → Gestionar cookies."
msgstr "You can change your decision at any time from Settings → Cookies → Manage cookies."

#: src/pages/Legal/PrivacyView.jsx
msgid "Puedes consultar qué cookies utilizamos en nuestra <0>política de cookies</0>."
msgstr "You can see which cookies we use in our <0>cookie policy</0>."

#: src/pages/Legal/PrivacyView.jsx
msgid "Puedes ejercer tus derechos de acceso, rectificación, supresión, oposición, limitación y portabilidad escribiendo a [PENDIENTE: privacy@…]. También puedes reclamar ante la Agencia Española de Protección de Datos (aepd.es)."
msgstr "You can exercise your rights of access, rectification, erasure, objection, restriction and portability by writing to [PENDING: privacy@…]. You can also lodge a complaint with the Spanish Data Protection Agency (aepd.es)."

#: src/components/common/ErrorBoundary/ErrorFallback.jsx
msgid "Puedes intentar recargar la página o cerrar sesión para limpiar los datos."
msgstr "You can try reloading the page or signing out to clear data."

#: src/pages/Onboarding/GroupView.jsx
msgid "Pulsa aquí"
msgstr "Click here"

#: src/pages/Mementos/tabs/MementosContributions/partials/ContributionFields/ContributionFields.jsx
msgid "Quién hizo la tarea"
msgstr "Who did the task"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Raciones"
msgstr "Servings"

#: src/pages/Register/RegisterView.jsx
msgid "Rápido y sin contraseña: sólo tu email y tu nombre."
msgstr "Quick and password-free: just your email and a name."

#: src/components/common/ErrorBoundary/ErrorFallback.jsx
msgid "Recargar"
msgstr "Reload"

#: src/pages/Recipes/RecipeDetail.jsx
#: src/pages/Recipes/RecipeShareView.jsx
msgid "Receta no encontrada"
msgstr "Recipe not found"

#: src/components/common/UsageLimit/usageUtils.jsx
#: src/Layouts/private/partials/AppSelector.jsx
msgid "Recetas"
msgstr "Recipes"

#: src/pages/Settings/Settings.jsx
msgid "Rechazadas"
msgstr "Rejected"

#: src/components/common/CookieConsentBanner/CookieConsentBanner.jsx
msgid "Rechazar"
msgstr "Reject"

#: src/components/common/CookieConsentBanner/CookieConsentBanner.jsx
msgid "Rechazar cookies"
msgstr "Reject cookies"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/Recommendations.jsx
msgid "Recomendaciones"
msgstr "Recommendations"

#: src/pages/Legal/CookiesView.jsx
msgid "Recordar tu decisión sobre las cookies."
msgstr "Remember your cookie decision."

#: src/pages/Login/partials/MagicLinkStep.jsx
msgid "Reenviar email"
msgstr "Resend email"

#: src/pages/Login/partials/MagicLinkStep.jsx
msgid "Reenviar email ({resendIn}s)"
msgstr "Resend email ({resendIn}s)"

#: src/pages/Login/LoginView.jsx
msgid "Registrarse"
msgstr "Sign up"

#: src/pages/Login/LoginView.jsx
msgid "Registrarte sólo te llevará 10 segundos."
msgstr "Signing up only takes 10 seconds."

#: src/pages/Register/RegisterView.jsx
msgid "Registro"
msgstr "Sign up"

#: src/components/common/ErrorBoundary/ErrorServer.jsx
#: src/pages/MagicLink/MagicLink.jsx
msgid "Reintentar"
msgstr "Retry"

#: src/components/Crew/CrewMembers/CrewMembers.jsx
msgid "Renovar enlace de invitación"
msgstr "Regenerate invitation link"

#: src/pages/Repair/RepairView.jsx
msgid "Reparar"
msgstr "Repair"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Repetir"
msgstr "Repeat"

#: src/pages/Economos/Movements/partials/EconomosRecurrenceSelector/EconomosRecurrenceSelector.jsx
msgid "Repetir hasta"
msgstr "Repeat until"

#: src/pages/Economos/Movements/partials/EconomosMonthBalance/EconomosMonthBalance.jsx
msgid "Restante:"
msgstr "Remaining:"

#: src/pages/Mementos/tabs/Mementos/Mementos.jsx
msgid "Resto"
msgstr "Rest"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/Calculator.jsx
msgid "Resultado:"
msgstr "Result:"

#: src/pages/Economos/Movements/partials/EconomosSummaryByTags/EconomosSummaryByTags.jsx
msgid "Resumen por etiquetas"
msgstr "Summary by tags"

#: src/pages/Login/partials/MagicLinkStep.jsx
msgid "Revisa tu email"
msgstr "Check your email"

#: src/components/Crew/CrewMembers/partials/CrewMember/CrewMember.jsx
msgid "Rol"
msgstr "Role"

#: src/components/Crew/CrewMembers/CrewMembers.jsx
msgid "Rol cambiado con éxito"
msgstr "Role changed successfully"

#: src/Layouts/private/partials/UserInfo.jsx
msgid "Salir"
msgstr "Sign out"

#: src/pages/Items/tabs/Items/Items.jsx
msgid "Salir del modo compra"
msgstr "Exit shopping mode"

#: src/pages/Items/tabs/Items/Items.jsx
msgid "Salir modo anclado"
msgstr "Exit pin mode"

#: src/pages/Mementos/tabs/Mementos/partials/MementoItem/MementoItem.jsx
msgid "Se activa {childDelayDays}"
msgstr "Activates {childDelayDays}"

#. placeholder {0}: daysSincePurchase ?? 0
#: src/pages/Items/tabs/Items/partials/HouseItem/partials/StockCountdown/StockCountdown.jsx
msgid "Se agota tras {outOfStockAfterDays}d · {0, plural, one {comprado hace # día} other {comprado hace # días}}"
msgstr "Runs out after {outOfStockAfterDays}d · {0, plural, one {bought # day ago} other {bought # days ago}}"

#: src/pages/Repair/RepairView.jsx
msgid "Se intentará reparar cualquier problema que puedas tener con la aplicación.<0/>Ten en cuenta que se cerrará la sesión."
msgstr "It will attempt to repair any issues you may have with the application.<0/>Note that you will be signed out."

#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
#: src/pages/Items/tabs/Predictions/Predictions.jsx
msgid "Se suele comprar cada {averageDays} días."
msgstr "Usually purchased every {averageDays} days."

#: src/pages/Economos/Movements/partials/EconomosItem/EconomosItem.jsx
msgid "Según la configuración de la lista, este movimiento inicia el mes"
msgstr "Per the list configuration, this movement starts the month"

#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
msgid "Selecciona"
msgstr "Select"

#: src/pages/SplitExpenses/partials/SplitExpenseFields.jsx
msgid "Selecciona al menos una persona"
msgstr "Select at least one person"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/DeleteMovementWithRecurrenceConfirmation.jsx
msgid "Selecciona el alcance de la eliminación. Esta acción no se puede deshacer."
msgstr "Select the scope of the deletion. This action cannot be undone."

#: src/components/common/ui/dates/Datepicker.jsx
msgid "Selecciona fecha"
msgstr "Select date"

#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
msgid "Selecciona la lista de destino"
msgstr "Select the destination list"

#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
msgid "Selecciona la lista de origen"
msgstr "Select the origin list"

#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
msgid "Selecciona otra tarea que active esta"
msgstr "Select another task that activates this one"

#: src/pages/Mementos/tabs/MementosContributions/partials/ContributionFields/ContributionFields.jsx
msgid "Selecciona quién hizo la tarea"
msgstr "Select who did the task"

#: src/pages/SplitExpenses/partials/SplitExpenseFields.jsx
msgid "Selecciona quién pagó"
msgstr "Select who paid"

#: src/pages/Settings/Settings.jsx
msgid "Selector de espacios siempre visible"
msgstr "Workspace selector always visible"

#: src/pages/Mementos/TasksDashboard/partials/TasksContributions/TasksContributions.jsx
msgid "Semana actual"
msgstr "Current week"

#: src/pages/Mementos/tabs/MementosContributions/MementosContributions.jsx
#: src/pages/Mementos/TasksDashboard/partials/TasksContributions/TasksContributions.jsx
msgid "Semana anterior"
msgstr "Previous week"

#: src/pages/Economos/Search/partials/DaterangeShortcuts/DaterangeShortcuts.jsx
msgid "Semana en curso"
msgstr "Current week"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Serie eliminada"
msgstr "Series deleted"

#: src/pages/Legal/CookiesView.jsx
msgid "Sesión"
msgstr "Session"

#: src/App.jsx
msgid "Sesión expirada"
msgstr "Session expired"

#: src/pages/Login/LoginView.jsx
#: src/pages/MagicLink/MagicLink.jsx
msgid "Sesión iniciada con éxito"
msgstr "Session started successfully"

#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
msgid "Si eliges una tarea, esta se activará al completarla. Déjalo vacío para una tarea independiente."
msgstr "If you pick a task, this one will be activated when it is completed. Leave it empty for a standalone task."

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
msgid "Si guardas, sobreescribirás sus cambios."
msgstr "If you save, you will overwrite their changes."

#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
msgid "Si no lo compras de nuevo, se marcará como agotado automáticamente."
msgstr "If you don't buy it again, it will be marked as out of stock automatically."

#: src/pages/Settings/Settings.jsx
msgid "Siempre"
msgstr "Always"

#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
#: src/pages/Items/tabs/Items/partials/HouseItemsShoppingMode/HouseItemsShoppingMode.jsx
msgid "Sin categoría"
msgstr "No category"

#: src/pages/Economos/Movements/partials/EconomosSummaryByTags/EconomosSummaryByTags.jsx
#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "Sin datos"
msgstr "No data"

#: src/pages/Economos/Dashboard/partials/DailyExpenseCard.jsx
msgid "Sin datos de proyección"
msgstr "No projection data"

#: src/pages/Economos/Dashboard/partials/DailyExpenseChart/DailyExpenseChart.jsx
msgid "Sin datos suficientes"
msgstr "Not enough data"

#: src/pages/SplitExpenses/SplitExpensesView.jsx
msgid "Sin gastos"
msgstr "No expenses"

#: src/pages/Economos/Dashboard/partials/CommonExpenses/CommonExpenses.jsx
msgid "Sin gastos este mes"
msgstr "No expenses this month"

#: src/pages/SplitExpenses/SplitExpensesGroupView.jsx
msgid "Sin grupos"
msgstr "No groups"

#: src/pages/Items/tabs/Items/partials/EmptyItems/EmptyItems.jsx
msgid "Sin ítems"
msgstr "No items"

#: src/pages/Economos/Movements/EconomosMovementsView.jsx
msgid "Sin movimientos"
msgstr "No movements"

#: src/pages/Economos/Dashboard/partials/RecentMovements.jsx
msgid "Sin movimientos recientes"
msgstr "No recent movements"

#: src/pages/Recipes/RecipesView.jsx
msgid "Sin recetas"
msgstr "No recipes"

#: src/pages/Settings/Settings.jsx
msgid "Sin responder"
msgstr "Not answered"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/TagsSelector.jsx
msgid "Sin resultados"
msgstr "No results"

#: src/pages/SplitExpenses/partials/SplitExpenseFields.jsx
msgid "Sin usuarios"
msgstr "No users"

#: src/pages/Settings/Settings.jsx
msgid "Solo el espacio actual"
msgstr "Only the current space"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/DeleteMovementWithRecurrenceConfirmation.jsx
msgid "Solo este movimiento"
msgstr "Only this movement"

#: src/pages/Legal/CookiesView.jsx
msgid "Solo si aceptas, el servicio de diagnóstico de errores Bugsnag (EE. UU.) recibe datos de errores y rendimiento para detectar y corregir incidencias. Si rechazas o retiras el consentimiento, no se carga ni se envía nada a Bugsnag. Más detalles en nuestra <0>política de privacidad</0>."
msgstr "Only if you accept, the Bugsnag error diagnostics service (USA) receives error and performance data to detect and fix issues. If you reject or withdraw consent, nothing is loaded or sent to Bugsnag. More details in our <0>privacy policy</0>."

#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
msgid "Stock: {stockLabel}"
msgstr "Stock: {stockLabel}"

#. placeholder {0}: getActionableTagDisplayName(tagToRemove)
#: src/pages/Economos/Movements/partials/EconomosItem/EconomosItem.jsx
msgid "Tag '{0}' eliminado"
msgstr "Tag '{0}' deleted"

#: src/pages/Legal/CookiesView.jsx
msgid "También puedes bloquear o eliminar cookies desde la configuración de tu navegador."
msgstr "You can also block or delete cookies from your browser settings."

#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
msgid "Tarea activadora"
msgstr "Triggering task"

#: src/components/common/UsageLimit/usageUtils.jsx
#: src/Layouts/private/partials/AppSelector.jsx
#: src/pages/Usage/UsageView.jsx
msgid "Tareas"
msgstr "Tasks"

#: src/pages/CrewInvitation/CrewInvitationView.jsx
msgid "Te han invitado a formar parte de"
msgstr "You've been invited to join"

#: src/pages/Legal/CookiesView.jsx
msgid "Técnica (exenta)"
msgstr "Technical (exempt)"

#: src/pages/Legal/TermsView.jsx
msgid "Términos y condiciones"
msgstr "Terms and conditions"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Tiempo"
msgstr "Time"

#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
msgid "Tiempo que pasa desde que la tarea activadora se completa hasta que esta tarea se activa."
msgstr "Time that passes from completing the triggering task until this task activates."

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/TagSelectorUncomittedTagWarning.jsx
msgid "Tienes etiquetas sin añadir"
msgstr "You have uncommitted tags"

#: src/pages/Legal/CookiesView.jsx
msgid "Tipo"
msgstr "Type"

#: src/pages/Onboarding/GroupView.jsx
msgid "Toda la información que almacenes se hará en el espacio seleccionado, de esta forma podrás separar (por ejemplo) \"Personal\" de \"Familia\"."
msgstr "All information you store will be saved in the selected workspace, this way you can separate (for example) \"Personal\" from \"Family\"."

#: src/pages/Items/tabs/Predictions/Predictions.jsx
msgid "Todavía no hay predicciones"
msgstr "No predictions yet"

#: src/pages/Mementos/TasksDashboard/partials/AllTasksDone/AllTasksDone.jsx
msgid "Todo en paz"
msgstr "All clear"

#: src/pages/Home/HomeView.jsx
msgid "Todo lo que tu hogar necesita,<0/>en un solo lugar"
msgstr "Everything your home needs,<0/>in one place"

#: src/components/common/ui/input/GroupedSelection/GroupedSelection.jsx
msgid "Todos"
msgstr "All"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/DeleteMovementWithRecurrenceConfirmation.jsx
msgid "Todos los de la serie"
msgstr "All in the series"

#: src/pages/Settings/Settings.jsx
msgid "Todos mis espacios"
msgstr "All my spaces"

#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "Total"
msgstr "Total"

#. placeholder {0}: totalExpenses.toFixed(2)
#: src/pages/SplitExpenses/SplitExpensesView.jsx
msgid "Total gasto: {0} €"
msgstr "Total expense: {0} €"

#: src/pages/Legal/TermsView.jsx
msgid "Trabajamos por ofrecer un servicio continuo, pero no garantizamos disponibilidad ininterrumpida ni ausencia de errores. En la máxima medida permitida por la ley, la responsabilidad se limita a los daños directos probados y, en ningún caso, a cantidades superiores a lo que hubieras pagado por el servicio en los 12 meses previos. Nada de lo aquí dispuesto excluye responsabilidades que no puedan limitarse por ley."
msgstr "We strive to offer a continuous service, but we do not guarantee uninterrupted availability or absence of errors. To the maximum extent permitted by law, liability is limited to proven direct damages and, in no case, to amounts greater than what you had paid for the service in the previous 12 months. Nothing herein excludes liabilities that cannot be limited by law."

#: src/pages/Economos/Movements/EconomosMovementsView.jsx
#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
msgid "Transferencia"
msgstr "Transfer"

#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
msgid "Transferencia creada"
msgstr "Transfer created"

#: src/pages/Login/LoginView.jsx
msgid "Tras iniciar sesión, te llevaremos a tu invitación."
msgstr "After signing in, we'll take you to your invitation."

#: src/pages/Login/LoginView.jsx
msgid "Tras iniciar sesión, te llevaremos de vuelta."
msgstr "After signing in, we'll take you back."

#: src/pages/Register/RegisterView.jsx
msgid "Tras registrarte, te llevaremos a tu invitación."
msgstr "After signing up, we'll take you to your invitation."

#: src/pages/Register/RegisterView.jsx
msgid "Tras registrarte, te llevaremos de vuelta."
msgstr "After signing up, we'll take you back."

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "ud, g, ml..."
msgstr "unit, g, ml..."

#: src/pages/Legal/LegalPage.jsx
msgid "Última actualización: 26/08/2026"
msgstr "Last updated: 26/08/2026"

#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
msgid "Última vez"
msgstr "Last time"

#: src/pages/Economos/Search/partials/DaterangeShortcuts/DaterangeShortcuts.jsx
msgid "Últimos 10 años"
msgstr "Last 10 years"

#: src/pages/Economos/Search/partials/DaterangeShortcuts/DaterangeShortcuts.jsx
msgid "Últimos 2 días"
msgstr "Last 2 days"

#: src/pages/Economos/Search/partials/DaterangeShortcuts/DaterangeShortcuts.jsx
msgid "Últimos 7 días"
msgstr "Last 7 days"

#: src/pages/Economos/Dashboard/partials/RecentMovements.jsx
msgid "Últimos movimientos"
msgstr "Recent movements"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Una descripción breve"
msgstr "A brief description"

#: src/pages/Settings/Settings.jsx
msgid "Una tarea inactiva no se podrá completar hasta que se active, pasado el tiempo configurado."
msgstr "A dormant task cannot be completed until it activates after the configured time."

#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Unidad"
msgstr "Unit"

#: src/pages/Items/tabs/Categories/HouseItemCategory/HouseItemCategory.jsx
msgid "Usada en {houseItemCount, plural, one {# ítem} other {# ítems}}"
msgstr "Used in {houseItemCount, plural, one {# item} other {# items}}"

#: src/components/common/CookieConsentBanner/CookieConsentBanner.jsx
msgid "Usamos cookies técnicas para que la app funcione y, solo si lo aceptas, cookies de diagnóstico de errores. <0>Más información</0>"
msgstr "We use technical cookies to make the app work and, only if you accept, error diagnostics cookies. <0>More information</0>"

#: src/components/common/ui/combobox/HouseItemCombobox.jsx
msgid "Usar"
msgstr "Use"

#. placeholder {0}: usageItem.limit
#: src/pages/Items/tabs/Items/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Usarías {wouldUse}/{0} ítems de tu plan actual"
msgstr "You would use {wouldUse}/{0} items of your current plan"

#. placeholder {0}: usageTask.limit
#: src/pages/Mementos/tabs/Mementos/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Usarías {wouldUse}/{0} tareas de tu plan actual"
msgstr "You would use {wouldUse}/{0} tasks of your current plan"

#: src/pages/Usage/UsageView.jsx
msgid "Uso del plan"
msgstr "Plan usage"

#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
msgid "Uso único"
msgstr "Single use"

#: src/Layouts/private/partials/UserInfo.jsx
msgid "Usuario: "
msgstr "User: "

#: src/pages/SplitExpenses/partials/SplitExpenseGroupFields.jsx
msgid "Usuarios"
msgstr "Users"

#: src/pages/Legal/PrivacyView.jsx
msgid "Utilizamos Bugsnag, Inc. (EE. UU.) como procesador de datos de diagnóstico de errores, únicamente si has aceptado las cookies no exentas. Dicha transferencia está amparada en las cláusulas contractuales tipo aprobadas por la Comisión Europea (decisión de ejecución 2021/914) y en el acuerdo de tratamiento de datos (DPA) suscrito con el proveedor."
msgstr "We use Bugsnag, Inc. (USA) as a processor of error diagnostics data, only if you have accepted non-exempt cookies. This transfer is covered by the standard contractual clauses approved by the European Commission (Implementing Decision 2021/914) and the data processing agreement (DPA) signed with the provider."

#: src/pages/MagicLink/MagicLink.jsx
msgid "Validando..."
msgstr "Validating..."

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/Calculator.jsx
msgid "Valor inicial:"
msgstr "Initial value:"

#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "Valor máximo"
msgstr "Maximum value"

#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "Valor medio"
msgstr "Average value"

#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "Valor mínimo"
msgstr "Minimum value"

#: src/pages/Economos/Movements/partials/EconomosSummaryByTags/EconomosSummaryByTags.jsx
msgid "Ver más"
msgstr "Show more"

#: src/pages/Economos/Movements/partials/EconomosSummaryByTags/EconomosSummaryByTags.jsx
msgid "Ver menos"
msgstr "Show less"

#: src/pages/Economos/Movements/partials/EconomosSummaryByTags/EconomosSummaryByTags.jsx
msgid "Ver resumen"
msgstr "View summary"

#: src/pages/Mementos/TasksDashboard/TasksDashboard.jsx
msgid "Ver tareas"
msgstr "View tasks"

#: src/pages/Economos/Dashboard/EconomosMovementsDashboard.jsx
#: src/pages/Economos/Dashboard/partials/RecentMovements.jsx
msgid "Ver todos"
msgstr "See all"

#: src/components/common/ErrorBoundary/ErrorServer.jsx
msgid "Verifica tu conexión a internet e inténtalo de nuevo."
msgstr "Check your internet connection and try again."

#: src/components/auth/HumanVerification/HumanVerification.jsx
msgid "Verificación humana"
msgstr "Human verification"

#: src/pages/SplitExpenses/partials/SplitExpenseGroupFields.jsx
msgid "Viaje, cena, piso..."
msgstr "Trip, dinner, rent..."

#: src/pages/Economos/Movements/partials/EconomosDateSelector/EconomosDateSelector.jsx
msgid "Volver a hoy"
msgstr "Back to today"

#: src/pages/CrewInvitation/CrewInvitationView.jsx
msgid "Volver a la app"
msgstr "Back to app"

#: src/pages/Login/partials/MagicLinkStep.jsx
#: src/pages/MagicLink/MagicLink.jsx
msgid "Volver al login"
msgstr "Back to login"

#: src/pages/Economos/Dashboard/partials/DailyExpenseCard.jsx
msgid "vs mes anterior"
msgstr "vs previous month"

#: src/pages/SplitExpenses/SplitExpensesView.jsx
msgid "y debe"
msgstr "and owes"

#: src/pages/Items/tabs/Predictions/Predictions.jsx
msgid "y que deberían haberse comprado, aparecerán en esta lista para ayudarte a tener los stocks al día."
msgstr "and that should have been purchased, will appear in this list to help you keep stock up to date."

#: src/pages/CrewInvitation/CrewInvitationView.jsx
msgid "Ya eres miembro de este espacio"
msgstr "You are already a member of this workspace"

#: src/pages/Onboarding/GroupView.jsx
msgid "Ya puedes empezar a usar todos los módulos:"
msgstr "You can now start using all modules:"

#: src/pages/Home/HomeView.jsx
msgid "Ya tengo cuenta"
msgstr "I already have an account"

#: src/pages/Mementos/tabs/Mementos/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Ya tienes esta tarea"
msgstr "You already have this task"

#: src/pages/Items/tabs/Items/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Ya tienes este ítem en la despensa"
msgstr "You already have this item in your pantry"

#: src/pages/Mementos/tabs/Mementos/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Ya tienes todas esas tareas"
msgstr "You already have all these tasks"

#: src/pages/Items/tabs/Items/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Ya tienes todos esos ítems"
msgstr "You already have all these items"
